import {
  Flex,
  Stack,
  Link as External,
  useBreakpointValue,
  Image,
  Heading,
  Divider,
  HStack,
  Box
} from '@chakra-ui/react'
import { 
  FaDiscord, 
  FaInstagram, 
  FaTwitter, 
  FaTelegramPlane, 
  FaLinkedinIn 
} from 'react-icons/fa'
import { 
  Histogram, 
  Rewards,
  Swap, 
} from '../Icons/Icons';
import { NavButton } from './NavButton'
import { SocialButton } from './SocialButton';
import { Link } from 'react-router-dom';
import "./styles/index.css"

export const Sidebar = ({ onClose }) => {
  const isDesktop = useBreakpointValue({base: false, lg: true, });

  return(
    <Flex
      flex="1"
      bg="#060203"
      overflowY="auto"
      className="gradient-border"
      overflowX="hidden"
      maxW={{ base: 'full', sm: 'xs', }}
      py={{ base: '6', sm: '8', }}
      px={{ base: '4', sm: '6', }}
    >
      <Stack justify="space-between" spacing="1">
        <Stack spacing={{  base: '4', sm: '5', }} shouldWrapChildren>
          <Flex p='3'><Image src="images/logo.svg" /></Flex>
          <HStack mt={5}>
            <Image width="35px" src="images/threeCircles.svg" />
            <Heading fontSize="2xl" fontWeight="semibold">Dashboard</Heading>
          </HStack>
          <Divider />
          <Stack spacing="8">
            <Link onClick={onClose} to="/stake"><NavButton label="Stake" image={<Histogram />} /></Link>
            <Link onClick={onClose} to="/rewards"><NavButton label="Rewards" image={<Rewards />} /></Link>
            <Link onClick={onClose} to="/swap"><NavButton label="Swap" image={<Swap />} /></Link>
            {/* <Link onClick={onClose} to="/avs"><NavButton label="Coming Soon" image={<ComingSoon />} /></Link> */}
          </Stack>
        </Stack>
        {!isDesktop ? 
          <Stack>
            <NavButton as={External} href="https://www.stackd.finance/" isExternal label="Home" />
            <NavButton as={External} href="https://www.stackd.finance/#Tokenomics" isExternal label="Tokenomics" />
            <NavButton as={External} href="https://www.stackd.finance/#Roadmap" isExternal label="Roadmap" />
            <NavButton as={External} href="https://www.stackd.finance/team" isExternal label="Team" />
            <NavButton as={External} href="https://www.stackd.finance/white-paper" isExternal label="Whitepaper" />
          </Stack>
          :
          null
        }
        <Stack spacing={{ base: '5', sm: '6', }}>
          <Divider width="150%" />
          <Box>
            <HStack mb={{base: '20', sm: "0" }} justifyContent="space-evenly">
              <SocialButton link="https://discord.gg/stackd" icon={<FaDiscord/>}/>
              <SocialButton link="https://www.instagram.com/stackdfinance/" icon={<FaInstagram/>}/>
              <SocialButton link="https://twitter.com/stackdfinance?lang=en" icon={<FaTwitter/>}/>
              <SocialButton link="https://t.me/StackdFinance" icon={<FaTelegramPlane/>}/>
              <SocialButton link="https://www.linkedin.com/company/stackd-finance/" icon={<FaLinkedinIn/>}/>
            </HStack>
          </Box>
        </Stack>
      </Stack>
    </Flex>
  )
}